import { Action } from "redux"

import * as actions from "./actions"
import { IWorkspaceListPage } from "./index"

export const initialState: IWorkspaceListPage = {
    filter: {
        isActive: true,
        code: "",
        label: "",
    },
    isLoading: false,
    pagination: {
        // DataApi index starts from 0, GdlApi from 1.
        // Latter will have the + 1 fix in the workspaces api wrapper
        currentPage: 0,
        // See Presenters/GDL/DataList.cs L55
        pageSize: 15,
        count: 0,
    },
    workspaces: [],
}

const ACTION_HANDLERS: {
    [action: string]: (
        state: IWorkspaceListPage,
        props: Action,
    ) => IWorkspaceListPage
} = {
    [actions.REQUEST_WORKSPACES]: (state): IWorkspaceListPage => ({
        ...state,
        isLoading: true,
    }),

    [actions.RECEIVE_WORKSPACES]: (
        state,
        { count, workspaces }: actions.ReceiveWorkspaces,
    ): IWorkspaceListPage => ({
        ...state,
        pagination: {
            ...state.pagination,
            count,
        },
        // if this is the first page, we replace otherwise we append
        workspaces:
            state.pagination.currentPage === 0
                ? workspaces
                : state.workspaces.concat(...workspaces),
        isLoading: false,
    }),

    [actions.FILTER_WORKSPACES]: (
        state,
        { code, label, isActive }: actions.Filter,
    ): IWorkspaceListPage => ({
        ...state,
        filter: {
            ...state.filter,
            code,
            label,
            isActive,
        },
        pagination: {
            ...state.pagination,
            currentPage: 0,
        },
        isLoading: true,
        workspaces: [],
    }),

    [actions.REFRESH_WORKSPACES]: (state): IWorkspaceListPage => ({
        ...state,
        filter: {
            isActive: true,
            code: "",
            label: "",
        },
        pagination: {
            ...state.pagination,
            currentPage: 0,
        },
        isLoading: true,
        workspaces: [],
    }),

    [actions.LOAD_MORE_WORKSPACES]: (state): IWorkspaceListPage => ({
        ...state,
        pagination: {
            ...state.pagination,
            currentPage: state.pagination.currentPage + 1,
        },
        isLoading: true,
    }),
}

export default function reducer(
    state = initialState,
    action: Action,
): IWorkspaceListPage {
    const handler: (
        state: IWorkspaceListPage,
        action: Action,
    ) => IWorkspaceListPage = ACTION_HANDLERS[action.type]
    return handler ? handler(state, action) : state
}
